<template>
    <div>
        <div @click="$emit('close')" class="w-full h-[100vh] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40 ">
            <div class="flex flex-col justify-center  z-40 bg-white w-[1000px]  max-h-[700px] text-lg rounded-lg border-[2px] border-[#006A00] relative ">
                <div class="pafcpic_header bg-[#006A00] py-3 px-6 ">
                    <p class="text-[#ffffff] text-md font-semibold">PAYSLIP FOR THE MONTH  OF {{ monthToWords(Data.pay_month) }} {{Data.pay_year}}</p>
                </div>
                <div v-if="loading" class="absolute bg-[#00000042] w-full h-full rounded-lg  flex justify-center items-center z-0" >
                    <span class="loader z-50"></span>
                </div>
                <div class="overflow-auto ">
                    <div class="pafcpic_body w-full px-12 ">
                        <div class="flex flex-col justify-center items-center gap-2 py-5">
                            <div class="text-center ">
                                <p class="text-sm font-semibold text-[#016B00]">PHILIPPINE ARMY FINANCE CENTER PRODUCERS INTEGRATED COOPERATIVE</p>
                                <p class="text-sm font-semibold text-[#016B00]">FORT BONIFACIO, TAGUIG CITY</p>
                            </div>
                            <div class="text-center ">
                                <p class="text-sm font-semibold text-[#016B00]">OFFICIAL STATEMENT OF EARNINGS and DEDUCTIONS</p>
                                <p class="text-sm font-semibold text-[#016B00]">FOR THE MONTH  OF {{ monthToWords(Data.pay_month) }} {{Data.pay_year}}</p>
                            </div>
                        </div>
                        <div class="grid grid-cols-2  mt-6">
                            <div class="col-span-1 flex">
                                <div class="pr-3">
                                    <p class="text-sm text-[#858282] ">Employee Code </p>
                                    <p class="text-sm text-[#858282] ">Name </p>
                                    <p class="text-sm text-[#858282] ">Salary Grade </p>
                                </div>
                                <div>
                                    <p class="text-sm text-[#858282] ">: </p>
                                    <p class="text-sm text-[#858282] ">: </p>
                                    <p class="text-sm text-[#858282] ">: </p>
                                </div>
                                <div class="pl-4">
                                    <p class="text-sm text-[#858282] ">N/A</p>
                                    <p class="text-sm text-[#858282] ">{{ Data.employee_name  }}</p>
                                    <p class="text-sm text-[#858282] ">N/A </p>
                                </div>
                            </div>
                            <div class="col-span-1 flex">
                                <div class="pr-4">
                                    <p class="text-sm text-[#858282] ">TIN</p>
                                    <p class="text-sm text-[#858282] ">SSS No.</p>
                                </div>
                                <div>
                                    <p class="text-sm text-[#858282] ">: </p>
                                    <p class="text-sm text-[#858282] ">: </p>
                                 
                                </div>
                                <div class="pl-4">
                                    <p class="text-sm text-[#858282] ">N/A</p>
                                    <p class="text-sm text-[#858282] ">N/A</p>
                                </div>    
                            </div>
                        </div>
                         <div class="flex w-full pt-1 border-t border-[#d6d6d6] mt-6 gap-1">
                            <div class="w-[50%] flex flex-col  items-center border border-[#3334] ">
                                <div class="text-center w-full">
                                    <p class="text-sm text-[#ffffff] font-semibold bg-[#026b00dc] py-2 ">Pay and Allowance</p>
                                </div>
                                <div v-if="enabled" class="w-full ">
                                    <div v-for="(earn,index) in info" :key="index" >
                                        <div v-if="earn.earnings" class="flex justify-between border-b border-[#026b0057] py-1.5">
                                            <div class=" w-full flex justify-between px-[20%]">
                                                <p class="text-sm text-[#858282] w-[65%]"> {{ payDesc(earn.earnings) }}</p>
                                                <p  class="text-sm text-[#858282]">{{ numberWithCommas(earn.amount) }}</p>
                                                <!-- <p class="text-sm text-[#858282] w-[65%]"> {{ payDesc(earn.earnings) }}</p>
                                                <p  class="text-sm text-[#858282]">{{ numberWithCommas(earn.amount) }}</p> -->
                                            </div>
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="w-[50%] flex flex-col  items-center border-x border-[#3334]"> 
                                <div class="text-center w-full">
                                    <p class="text-sm text-[#ffffff] font-semibold bg-[#026b00dc] py-2 ">Deductions</p>
                                </div>
                                <div v-if="enabled" class=" w-full">
                                    <div  v-for="(deduc,index) in info" :key="index" class="">
                                        <div v-if="!deduc.earnings && deduc.amount != '.00'" class="flex justify-between border-b border-[#026b0057]  py-1.5">
                                            <div class=" w-full flex justify-between px-[20%]">
                                                <p class="text-sm text-[#858282] w-[65%]"> {{ dedDesc(deduc.deduction) }}</p>
                                                <p  class="text-sm text-[#858282]">{{ numberWithCommas(deduc.amount) }}</p>
                                                <!-- <p class="text-sm text-[#858282]">{{ dedDesc(deduc.deduction) }}</p>
                                                <p  class="text-sm text-[#858282]">{{ numberWithCommas(deduc.amount)   }}</p> -->
                                             </div>   
                                        </div>
                                    </div>
                                 
                                </div>
                            </div>
                        </div> 
                        <div class=" w-full flex gap-1 " >
                            <div class="w-[50%] flex flex-col justify-center items-center">
                               
                                <div class=" w-[100%]">
                                    <div class="flex justify-between px-[20%] border-x border-b border-[#026b0057] py-1.5">
                                        <p class="text-sm text-[#858282] font-semibold ">Total Earnings</p>
                                        <p class="text-sm text-[#858282] font-semibold ">{{ numberWithCommas(totalEarnings) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-[50%] flex flex-col justify-center items-center">
                                <div class=" w-full">
                                    <div class="flex justify-between px-[20%] border-b border-x  border-[#026b0057]  py-1.5">
                                        <p class="text-sm text-[#858282] font-semibold ">Total Deductions</p>
                                        <p class="text-sm text-[#858282] font-semibold  ">{{numberWithCommas(totalDeductions)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="py-3 border-t border-[#d6d6d6] mt-6">
                    <p class="text-sm  text-[#818080] px-12 pb-2 ">NET PAY   :   {{ word }} PESOS ONLY {{ "₱ " + numberWithCommas(totalNetPay)}}</p>
                    <p class="text-sm  text-[#818080] px-12 py-1">15th Pay  : {{ numberWithCommas(this.cut15) }}  </p>
                    <p class="text-sm  text-[#818080] px-12 py-1">EOM Pay   :   {{ numberWithCommas(this.cut30) }}</p>
                </div>
                <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t">
                    <button class="text-sm text-white bg-[#006A00] py-3 font-semibold px-10 rounded-md hover:bg-[#00000046]" @click="$emit('viewPDF',Data.employee_name,word,numberWithCommas(this.cut15),numberWithCommas(this.cut30),numberWithCommas(totalNetPay),numberWithCommas(totalEarnings),numberWithCommas(totalDeductions),info)">VIEW PDF</button>
                    <button class="text-sm text-white bg-[#006A00] py-3 font-semibold px-10 rounded-md hover:bg-[#00000046]" @click="$emit('close')">Close</button>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
import numberToWords from 'number-to-words';
import { defineComponent } from 'vue';
import Services from "../../../services/admin"
    // // import EditButton from "../../controls/Button/EditControl.vue"
    // import DeleteButton from "../Button/DeleteControl.vue"

export default defineComponent({
    components:{
            // EditButton,
            // DeleteButton
    },
    data(){
        return {
            paycode:null,
            dedcode:null,
            enabled:false,
            loading:false,
            PayrollInfo:'',
            info:[],
            totalEarnings: 0,
            totalDeductions: 0,
            test:[],
            totalNetPay:0,
            cut15:0,
            cut30:0,
            payDescription:[],
            testss:'',
            monthDesc:[
                {
                monthID: '01',
                month:'JANUARY'
                },
                {
                monthID: '02',
                month:'FEBRUARY'
                },
                {
                monthID: '03',
                month:'MARCH'
                },
                {
                monthID: '04',
                month:'APRIL'
                },
                {
                monthID: '05',
                month:'MAY'
                },
                {
                monthID: '06',
                month:'JUNE'
                },
                {
                monthID: '07',
                month:'JULY'
                },
                {
                monthID: '08',
                month:'AUGUST'
                },
                {
                monthID: '09',
                month:'SEPTEMBER'
                },
                {
                monthID: '10',
                month:'OCTOBER'
                },
                {
                monthID: '11',
                month:'NOVEMBER'
                },
                {
                monthID: '12',
                month:'DECEMBER'
                },
                
                
            ],
        }
    },
    props:{
        Data: {
            type: Object,
            default: null,
        },
        PayData:{
            type: Object,
            default: null,
        }   
    },
    created(){
        this.paycode = this.PayData.paycode
        this.dedcode = this.PayData.dedcode
        this.PayrollInfo    = this.Data
        this.getPay()
    },

    async mounted(){
        
        // await this.addEarnings()
    },
    methods:{
        testingggg(){
            this.enabled = true
        },
         async getPay(){
            this.loading = true
            const success = await Services.getPayssss(this.PayrollInfo.employee_id,this.PayrollInfo.pay_month,this.PayrollInfo.pay_year);
            this.info = success.data;
            this.enabled = true
            await this.addEarnings();
            await this.addDedeuc();
            await this.totalNet();
           
            this.loading = false
         },
         addEarnings(){
            this.loading = true
            for(let i = 0;i < this.info.length;i++){
                if(this.info[i].earnings){

                    this.totalEarnings = (Number(this.totalEarnings) + Number(this.info[i].amount)).toFixed(2)
                }
            }
            this.loading = false
         },
         addDedeuc(){
            for(let i = 0;i < this.info.length;i++){
                
                if(this.info[i].deduction){
                 
                    this.totalDeductions = (Number(this.totalDeductions) + Number(this.info[i].amount)).toFixed(2)
                }
            } 
         },
         totalNet(){

            this.totalNetPay = (Number(this.totalEarnings) - Number(this.totalDeductions)).toFixed(2)

            this.word  = (numberToWords.toWords(this.totalNetPay)).toUpperCase();
            let  cut15 =   Math.round(this.totalNetPay) / 2
            this.cut15 =   (Math.ceil(cut15 / 100) * 100).toFixed(2)
            this.cut30 =  (Number(this.totalNetPay) - Number(this.cut15)).toFixed(2)
         },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        },
        payDesc(pay){
            let state = this.$store.state
            const payItem = state.pay_desc.paycode.find(item => item.paycode === pay);
            return payItem ? payItem.fulldesc : undefined; // Return undefined if not found
        },
        dedDesc(ded) {
            let state = this.$store.state
            const dedItem = state.pay_desc.dedcode.find(item => item.dedcode === ded);
            return dedItem ? `${dedItem.agency}-${dedItem.deddesc}` : undefined; // Return undefined if not found
        },
        // payDesc(pay){
        //     this.testss = this.paycode.filter(paycode=>paycode.paycode == pay)
        //     return  this.testss[0].fulldesc
        // },
        // dedDesc(ded){
        //     this.testss = this.dedcode.filter(dedcode=>dedcode.dedcode == ded)
        //     return  this.testss[0].agency + '-' + this.testss[0].deddesc
        // },
        monthToWords(codes){
            const code = String(codes).padStart(2, '0'); // inputCode can be a number like 3 or string like '3'
            const result = this.monthDesc.find(months => months.monthID === code);
            if (result) {

                return result.month;
            } else {
                return null;
            }
        } 
    }
})
    </script>

<style scoped>
table tr th{
    background-color: #006A00;
    padding: 15px 0px;
    position:sticky;
    top:0;
}
tr td{
    height: 20px;
    text-align: center;
    padding: 10px 1px;
    color: #5f615f;
    border-bottom: 1px solid rgb(177, 175, 175);
    font-weight: 600;
}
.loader {
    width: 30px;
    height: 30px;
    border: 5px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
} 
@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
} 
</style>